import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { config } from '~/notes/api/rtk/config'
import { sec } from '~/notes/api/rtk/security'

export const blank = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: config.meshingApi.baseUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      headers.set(
        'X-Timezone',
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      )
      return headers
    },
    credentials: 'include',
  }),
  endpoints: () => ({}),
  reducerPath: 'meshing',
})
